import { Buffer } from 'buffer'
import ReactDOM from 'react-dom/client'

if (typeof globalThis.Buffer === 'undefined') {
  globalThis.Buffer = Buffer
}
import { Suspense } from 'react'
import { Provider } from 'react-redux'
import App from './App'
import { initBeforeAuth } from './app/init/beforeAuth/initBeforeAuth'
import { registerChunkLoadRecovery } from './app/init/beforeAuth/registerChunkLoadRecovery'
import './app/init/beforeAuth/language/i18n'
import { I18nSuspenseFallback } from './app/init/beforeAuth/language/I18nSuspenseFallback'
import { store } from './app/redux/store'
import reportWebVitals from './reportWebVitals'

// Load manifest on non-dev builds only (Verified Access on dev blocks /manifest.json)
if (typeof window !== 'undefined' && import.meta.env.VITE_APP_ENV !== 'dev') {
  const link = document.createElement('link')
  link.rel = 'manifest'
  link.href = `${import.meta.env.BASE_URL || '/'}manifest.json`
  document.head.appendChild(link)
}

// index.html preloads this image for LCP. Chrome warns if a preload isn't used shortly after load.
// Creating an Image early makes the preload intentional and avoids the "preloaded but not used" warning.
const ecommanderLogoUrl = `${import.meta.env.BASE_URL || '/'}images/ecommander.png`
const preloadEcommanderLogo = () => {
  const img = new Image()
  img.src = ecommanderLogoUrl
}
preloadEcommanderLogo()
registerChunkLoadRecovery()

// Suppress findDOMNode deprecation warning from react-quill-ver2
// This is a known issue in react-quill-ver2 and doesn't affect functionality
if (import.meta.env.MODE === 'development') {
  const originalError = console.error
  console.error = (...args: any[]) => {
    // Check if this is specifically the findDOMNode warning from react-quill-ver2
    // We check for both the warning text AND ReactQuill in the stack to avoid false positives
    const firstArg = args[0]
    const isFindDOMNodeWarning = typeof firstArg === 'string' && firstArg.includes('findDOMNode is deprecated')

    if (isFindDOMNodeWarning) {
      // Check if ReactQuill is mentioned in any of the arguments (component stack)
      const hasReactQuill = args.some((arg) => {
        const argStr = typeof arg === 'string' ? arg : String(arg)
        return argStr.includes('ReactQuill') || argStr.includes('react-quill')
      })

      // Only suppress if it's from ReactQuill to avoid masking legitimate errors
      if (hasReactQuill) {
        return // Suppress this specific warning
      }
    }

    originalError.apply(console, args)
  }
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

initBeforeAuth().then(() => {
  root.render(
    <Provider store={store}>
      <Suspense fallback={<I18nSuspenseFallback />}>
        <App />
      </Suspense>
    </Provider>
  )
})

// Measure and log performance metrics
// Metrics are automatically logged and compared between environments
reportWebVitals()
